import Qs from 'qs';
import instance from './api-client';

export const getCustomerNotifications = (filter: any = null) => {
  if (filter?.tab) {
    filter.tab = undefined;
  }
  return instance.get('/notifications', {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
  });
};

export const notificationMarkAsRead = (id: string | number) => {
  return instance.put(`/notifications/${id}/mark-as-read`);
};
